import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    text :{
        fontSize: '18px',
    },
    wrapper: {
        padding: theme.spacing(2),
    },
}));
